import { useContext, useEffect } from "react"
import { UserContext } from "../../../../../App"
import { useCheckout } from "../../functions/useCheckout"
import Modal from "../../modal"
import { LoadingFull } from "../../../../loading"
import dao from '../../../../../assets/img/dao.png'
import ModalAddress from "../address/modalAddress"

export function ChoosePoint({selected, setShipment, openServicePoints, setOpenServicePoints, openAddress, setOpenAddress, address, setAddress, getServicePoints, servicePoints}) {
  const { user } = useContext(UserContext)

  useEffect(() => {
    getServicePoints()
  }, [address])

  useEffect(() => {
    if (typeof address === 'undefined') {
      setOpenAddress(true)
    }
  }, [openServicePoints])

  return (
    <Modal width={"w-[80%] lg:w-2/5"} height={typeof address === 'undefined' || openAddress ? "h-fit" : "4/5"} open={openServicePoints} onClose={() => setOpenServicePoints(false) & setOpenAddress(false)}>
      {openServicePoints ?
        typeof address === 'undefined' || openAddress ?
          <ModalAddress address={address} setAddress={setAddress} openServicePoints={openServicePoints} setOpenAddress={setOpenAddress} />
        : servicePoints.length === 0 || typeof selected === 'undefined' ?
          <LoadingFull />
        :
          <div className="flex flex-col h-full gap-5">
            <div className="title">
              <h3 className="text-xl md:text-2xl font-bold">Afhentningssteder</h3>
              <p className="text-sm lg:text-base">{servicePoints.length} afhentningssteder fundet</p>
              <p onClick={setOpenAddress} className="text-emerald-700 hover:text-emerald-800 underline text-sm cursor-pointer w-fit">Rediger adresse</p>
            </div>
            <div className="overflow-y-scroll overflow-x-hidden grid grid-cols-2">
              {servicePoints.map((point, index) => {
                return (
                  <div className="py-5 border border-gray-100 flex justify-between px-2">
                    <div className="transition-[opacity_0.2s] text-xs lg:text-sm w-full flex flex-col gap-2">
                      <div className="h-full">
                        <div className="flex gap-2 items-center">
                          <p className="font-semibold">{point.name}</p> 
                        </div>
                        <div className="address">
                          <p className="">{point.address}</p>
                          <p>{point.zipcode}, {point.city}</p>
                        </div>
                      </div>
                      <div className="py-2 border border-emerald-600 text-center hover:bg-emerald-600 hover:text-white transition-[] cursor-pointer" onClick={() => setShipment(prev => {
                        const ss = prev.find(a => a.seller.id === selected)
                        ss['service_point'] = {
                            'id': point.id,
                            'name': point.name,
                            'address1': point.address,
                            'address2': point.address2,
                            'zipcode': point.zipcode,
                            'city': point.city,
                            'country_code': point.country,
                            'agent': point.agent
                        }
                        return [...prev]
                      }) & setOpenServicePoints(false)}>
                        Vælg
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
      :
        ""}
    </Modal>
  )
}